import React, { useEffect, useState } from "react";
import { fetchUPFeedData } from "./UserPickFetchData.js";
import "../../Styles/UserPickFeedData.css";
import ShareButton from "../../../../common/Actions/shareButton.js";
import LikeButton from "../../../../common/Actions/likeButton.js";
import SuggestButton from "../../../../common/Actions/suggestButton.js";
import Carousel from "../../../../common/Carousel/Carousel.js";
import GridLayout from "../../../../common/Grid/gridMode.js";
import LightboxGallery from "../../../../common/LightBox/lightBox.js";
import HorizontalScrollDisplay from "../../../../common/HorizontalScroll/horizontalScroll.js";
import VerticalScroll from "../../../../common/VerticalScroll/verticalScroll.js";

const UPFeedContent = ({ userId, mediaDisplayMode }) => {
  const [feedData, setFeedData] = useState({ feeds: [] });

  useEffect(() => {
    const loadFeedData = async () => {
      const data = await fetchUPFeedData();
      setFeedData(data);
    };
    loadFeedData();
  }, []);

  return (
    <div className="up-grid-layout">
      <div className="up-feed-container">
        {Array.isArray(feedData?.feeds) &&
          feedData.feeds.map((user) => (
            <div key={user.userUUID} className="up-user-feed">
              {/* User Header */}
              <div className="up-user-container" >
                <img
                  src={user.userImageUrl}
                  alt={user.userName}
                  className="up-user-images"
                />
                <div style={{marginTop: 10}}>
                  <p className="text-header" style={{ margin: 0 }}>
                    {user.userName}{" "}
                    {user.BlueTickStatus && (
                      <span style={{ color: "bright blue", fontSize: 16 }}>✔️</span>
                    )}
                  </p>
                  <p className="text-label" style={{ margin: 0 }}>
                    {user.profile} | {user.location}
                  </p>
                </div>
              </div>

              {/* User Posts */}
              {Array.isArray(user.posts) &&
                user.posts.map((post) => (
                  <div
                    key={post.postId}
                    className="up-post-card"
                  >
                    {/* Post Header */}
                    <div>
                      <p className="text-label" style={{ margin: "5px 0" }}>
                        {post.descriptions}
                      </p>
                      <p className="text-label" style={{ margin: "0 0 10px 0", fontSize: 16 }}>
                        {post.location} • {new Date(post.timestamp).toLocaleString()}
                      </p>
                    </div>

                    {/* Post Media */}
                    <div className="mp-feed-media" style={{ marginTop: 5, marginLeft: -10 }}>
                      {Array.isArray(post.medias) && post.medias.length > 0 && (
                        <>
                          {mediaDisplayMode === "slideshow" ? (
                            <Carousel items={post.medias.map((m) => m.mediaurl)} />
                          ) : mediaDisplayMode === "lightbox" ? (
                            <LightboxGallery mediaFiles={post.medias.map((m) => m.mediaurl)} />
                          ) : mediaDisplayMode === "horizontal-scroll" ? (
                            <HorizontalScrollDisplay medias={post.medias} />
                          ) : mediaDisplayMode === "vertical-scroll" ? (
                            <VerticalScroll medias={post.medias} />
                          ) : (
                            <GridLayout mediaFiles={post.medias} />
                          )}
                        </>
                      )}
                    </div>

                    {/* Post Actions */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 10,
                      }}
                    >
                      <div
                        className="mp-post-stats-left"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 20,
                          fontSize: 14,
                        }}
                      >
                        <LikeButton count={post.nlikes} style={{ fontSize: 14 }} />
                        <ShareButton count={post.nshares} />
                        <SuggestButton />
                      </div>
                      <div className="mp-post-stats-right">
                        <span
                          className="text-label"
                          style={{
                            fontSize: 18,
                            marginTop: 20,
                            marginRight: 10,
                            color: "white",
                            fontWeight: "normal",
                          }}
                        >
                          👀 {post.impressions || 0} Impressions
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          ))}
      </div>
    </div>
  );
};

export default UPFeedContent;
